import React from 'react';
import Image from 'next/image';
import SectionHeading from '../Common/SectionHeading';

const WorkWithUs = ({title=null}) => {
    return (
        <>
            <div className="bg-[#ecf5fe] w-full">
                <div className="w-11/12 xl:max-w-screen max-w-screen-2xl mx-auto lg:py-8 py-4">
                    <SectionHeading title={title}  customClass="text-center" />
                    <div className="grid grid-cols-12 gap-6">
                        {WorkWithData?.map((item,i) => (
                            <div className="lg:col-span-3 md:col-span-6 col-span-12" key={i}>
                                <Image priority={false} src={process.env.IMG_CDN+item?.imgSrc} width={2000} height={2000} alt={item?.name} className="w-20 mx-auto"/>
                                <h4 className="text-xl font-semibold text-center">{item?.name}</h4>
                                <p className="text-base text-center">{item?.desc}</p>
                            </div>
                        ))}
                    </div>  
                </div>
            </div>
        </>
    )
}
export default WorkWithUs;

const WorkWithData = [
    {
        imgSrc: 'img/careers/svg/learn-with-us.svg',
        name: 'Learn with Us',
        desc: 'Learning is a journey, and we encourage our employees to retain knowledge and experiment with different approaches to add more value to their work.'
    },
    {
        imgSrc: 'img/careers/svg/we-embrace-change.svg',
        name: 'We Embrace Change',
        desc: 'Change is natural. To strive in this highly competitive world, we encourage transition from one level to another for better growth prospects.'
    },
    {
        imgSrc: 'img/careers/svg/we-value-efforts.svg',
        name: 'We Value Efforts',
        desc: 'We encourage our employees who are passionate about their work and do not hesitate to take the extra mile to cope with the hurdles.'
    },
    {
        imgSrc: 'img/careers/svg/we-care-for-our-employees.svg',
        name: 'We Care',
        desc: 'Work is important. And so is recreation. We promote a homely atmosphere to give employees a break from routine work and feel more catered to.'
    },

]
